import m from 'moment';
import axios from 'axios';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

main();

let localActiveOutlet = localStorage.getItem('active_outlet');
let localActiveOutletCurrency = localStorage.getItem('active_outlet_currency');
let localActiveTill = localStorage.getItem('active_till');
let localActiveTillCurrency = localStorage.getItem('active_till_currency');
let localStartMonth = localStorage.getItem('start_month');
let localEndMonth = localStorage.getItem('end_month');
let localTypeDate = localStorage.getItem('timezones');
let localTimezone = localStorage.getItem('getZone');

let startDate = m().startOf('day');
let endDate = m().endOf('day');

let startMonth =
    localStartMonth == null
        ? m()
              .startOf('month')
              .utcOffset(0, true)
        : m(localStartMonth);
let endMonth =
    localEndMonth == null
        ? m()
              .endOf('day')
              .utcOffset(0, true)
        : m(localEndMonth);

let localSessionId = localStorage.getItem('drawer_session_id');

const activeOutletAlwaysAllOutlets = [
    '/franchise/product',
    '/franchise/pricebook',
    '/inventory/supplier',
];

const currentUrl = window.location.pathname;

const state = {
    activeOutlet:
        localActiveOutlet == null ||
        activeOutletAlwaysAllOutlets.includes(currentUrl)
            ? 0
            : localActiveOutlet,
    activeOutletCurrency: localActiveOutletCurrency || null,
    activeTill: localActiveTill == null ? 0 : localActiveTill,
    activeTillCurrency: localActiveTillCurrency || '',
    startDate: startDate,
    endDate: endDate,
    startMonth: startMonth,
    endMonth: endMonth,
    type: localTypeDate ? localTypeDate : 'UTC',
    outlets: [],
    tills: [],
    dateFilter: {
        since: startDate.format(),
        until: endDate.format(),
    },
    monthFilter: {
        since_month: startMonth.format(),
        until_month: endMonth.format(),
    },
    drawer_session_id: localSessionId == null ? null : localSessionId,
    activeTableName: null,
    oldActiveValue: [],
    timezone: localTimezone,
};

const getters = {
    dateFilter(state) {
        return state.dateFilter;
    },

    monthFilter(state) {
        return state.monthFilter;
    },

    startDate(state) {
        return state.startDate;
    },

    endDate(state) {
        return state.endDate;
    },

    typeDate(state) {
        return state.type;
    },

    timeZone(state) {
        return state.timezone;
    },

    startMonth(state) {
        return state.startMonth;
    },

    startMonth2(state) {
        return state.startMonth;
    },

    endMonth2(state) {
        return state.endMonth.format();
    },

    endMonth(state) {
        return state.endMonth;
    },

    activeOutlet(state) {
        return state.activeOutlet;
    },

    activeOutletCurrency(state) {
        return state.activeOutletCurrency;
    },

    currency(state) {
        let currency = state.activeOutletCurrency;

        if (_.isEmpty(currency) || currency === 'null') {
            return null;
        } else {
            if (_.isString(currency)) {
                currency = JSON.parse(currency);
            }

            return currency.symbol;
        }
    },

    outletList() {
        return state.outlets;
    },

    findOutletById: state => outlet_id => {
        return state.outlets.find(o => o.id == outlet_id);
    },

    drawerSessionId(state) {
        return state.drawer_session_id;
    },

    activeTill(state) {
        return state.activeTill;
    },

    activeTillCurrency(state) {
        return state.activeTillCurrency;
    },

    tillList() {
        return state.tills;
    },

    findTillById: state => tills_id => {
        return state.tills.find(o => o.id == tills_id);
    },

    activeTableName(state) {
        return state.activeTableName;
    },

    oldActiveValue() {
        return state.oldActiveValue;
    },
};

const mutations = {
    setReportRange(state, range) {
        state.startDate = range.start;
        state.endDate = range.end;
        state.drawer_session_id = range.drawer_session_id;

        state.dateFilter = {
            since: state.startDate.format(),
            until: state.endDate.format(),
        };

        localStorage.setItem('start_date', range.start.toISOString());
        localStorage.setItem('end_date', range.end.toISOString());

        if (range.drawer_session_id) {
            localStorage.setItem('drawer_session_id', range.drawer_session_id);
            localStorage.setItem('sequence_number', range.sequence_number);
        }
    },

    setMonthReportRange(state, range) {
        state.startMonth = range.start;
        state.endMonth = range.end;

        state.monthFilter = {
            since_month: state.startMonth.format(),
            until_month: state.endMonth.format(),
        };

        localStorage.setItem('start_month', range.start.toISOString());
        localStorage.setItem('end_month', range.end.toISOString());
    },

    setActiveAllOutlets(state, id) {
        state.activeOutlet = id;
        setActiveOutletCurrency(state, id);
    },

    setTypeDate(state, type) {
        state.type = type;
    },
    setOutletTimezone(state, id) {
        let offset = '+08:00';
        let zone = 'Asia/Kuala_Lumpur';
        if (id != 0) {
            let preference = state.outlets.find(o => o.id == id);

            if (preference != undefined) {
                zone = preference.preference.timezone;
                offset = preference.preference.timezone_offset;
                if (offset == null || offset == '') {
                    offset = window.slurp.auth.franchise
                        ? window.slurp.auth.franchise.timezone_offset
                        : null;
                    zone = window.slurp.auth.franchise
                        ? window.slurp.auth.franchise.timezone
                        : null;
                }
            }
        } else if (id == 0 || null) {
            offset = window.slurp.auth.franchise
                ? window.slurp.auth.franchise.timezone_offset
                : null;
            zone = window.slurp.auth.franchise
                ? window.slurp.auth.franchise.timezone
                : null;
        }

        localStorage.setItem('getZone', zone);
        localStorage.setItem('getZoneoffset', offset);
        state.timezone = zone;
    },

    setActiveOutlet(state, id) {
        state.activeOutlet = id;
        if (id == 0) {
            id = state.outlets[0].id;
        }
        localStorage.setItem('active_outlet', id);
        setActiveOutletCurrency(state, id);
    },

    setActiveFirstOutlet(state) {
        let id = null;
        let zone = null;
        let offset = null;

        id = state.outlets.some(o => o.id == state.activeOutlet)
            ? state.activeOutlet
            : state.outlets[0].id;
        state.activeOutlet = id;
        localStorage.setItem('active_outlet', id);

        if (id != 0) {
            const preference = state.outlets.find(o => o.id == id);
            zone = preference ? preference.preference.timezone : null;
            offset = preference ? preference.preference.timezone_offset : null;

            if (!offset) {
                offset = window.slurp.auth.franchise
                    ? window.slurp.auth.franchise.timezone_offset
                    : null;
                zone = window.slurp.auth.franchise
                    ? window.slurp.auth.franchise.timezone
                    : null;
            }
        } else if (id == 0 || id == null) {
            offset = window.slurp.auth.franchise
                ? window.slurp.auth.franchise.timezone_offset
                : null;
            zone = window.slurp.auth.franchise
                ? window.slurp.auth.franchise.timezone
                : null;
        }

        if (!offset || !zone) {
            offset = '+08:00';
            zone = 'Asia/Kuala_Lumpur';
        }

        localStorage.setItem('getZone', zone);
        localStorage.setItem('getZoneoffset', offset);
        state.timezone = zone;

        setActiveOutletCurrency(state, id);
    },

    setOutletList(state, outlets) {
        state.outlets = outlets;
    },

    setTillList(state, tills) {
        state.tills = tills;
    },

    setActiveAllTills(state) {
        this.setActiveTill(state, 0);
    },

    setActiveTill(state, id) {
        state.activeTill = id;
    },

    setActiveTableName(state, data) {
        state.activeTableName = data;
    },

    setOldActiveValue(state, data) {
        state.oldActiveValue = data;
    },

    setOutletCurrencyIfNecessary(state, id) {
        setActiveOutletCurrency(state, id);
    },

    clearLocalMonth() {
        localStorage.removeItem('start_month');
        localStorage.removeItem('end_month');
    },
};

const actions = {
    async getOutletList({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-report-outlet');

        let api = Laroute.route('franchise.vue.outlets');

        return axios.get(api, options).then(res => {
            let data = res.data.data;

            commit('setOutletList', data);
            endLoading(dispatch, 'fetch-report-outlet');

            return data;
        });
    },

    async getTillList({ commit }, id) {
        let route = Laroute.route('franchise.report.till_closure.till-list', {
            id,
        });
        try {
            const res = await axios.get(route);
            commit('setTillList', res.data.data);
            return res;
        } catch (err) {
            throw err;
        }
    },
};

function main() {
    if (shouldClearLocalStorage()) {
        clearLocalStorage();
    }

    setLastActive();
}

function getLastActive() {
    let lastActive = localStorage.getItem('last_active');

    if (lastActive != null) {
        return m(lastActive);
    }

    return null;
}

function setLastActive() {
    localStorage.setItem('last_active', m().toISOString());
}

function setActiveOutletCurrency(state, outlet_id) {
    if (!hasOutletId(outlet_id)) {
        resetCurrencyValue(state);
        return;
    }

    let outlet = state.outlets.find(o => o.id == outlet_id);

    if (outlet != null) {
        state.activeOutletCurrency = outlet.currency;
        localStorage.setItem(
            'active_outlet_currency',
            JSON.stringify(outlet.currency),
        );
    } else {
        resetCurrencyValue(state);
    }
}

function hasOutletId(id) {
    return id != null && id != 0;
}

function resetCurrencyValue(state) {
    state.activeOutletCurrency = '';
    localStorage.setItem('active_outlet_currency', '');
}

function shouldClearLocalStorage() {
    let lastActive = getLastActive();

    if (lastActive != null) {
        let now = m();
        return now.diff(lastActive, 'hours') > 8;
    }

    return false;
}

function clearLocalStorage() {
    localStorage.removeItem('active_outlet');
    //localStorage.removeItem('timezones');
    localStorage.removeItem('active_outlet_currency');
    localStorage.removeItem('start_date');
    localStorage.removeItem('end_date');
    localStorage.removeItem('start_month');
    localStorage.removeItem('end_month');
    localStorage.removeItem('drawer_session_id');
}

export default {
    state,
    getters,
    mutations,
    actions,
};
